var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudiLogUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49912 6C7.49912 4.80653 7.97323 3.66193 8.81714 2.81802C9.66105 1.97411 10.8056 1.5 11.9991 1.5C13.1926 1.5 14.3372 1.97411 15.1811 2.81802C16.025 3.66193 16.4991 4.80653 16.4991 6C16.4991 7.19347 16.025 8.33807 15.1811 9.18198C14.3372 10.0259 13.1926 10.5 11.9991 10.5C10.8056 10.5 9.66105 10.0259 8.81714 9.18198C7.97323 8.33807 7.49912 7.19347 7.49912 6ZM3.75012 20.105C3.78384 17.9395 4.66776 15.8741 6.21108 14.3546C7.7544 12.8351 9.83333 11.9834 11.9991 11.9834C14.1649 11.9834 16.2438 12.8351 17.7872 14.3546C19.3305 15.8741 20.2144 17.9395 20.2481 20.105C20.2507 20.2508 20.2108 20.3942 20.1332 20.5176C20.0555 20.641 19.9436 20.7392 19.8111 20.8C17.3603 21.9237 14.6953 22.5037 11.9991 22.5C9.21312 22.5 6.56612 21.892 4.18712 20.8C4.05461 20.7392 3.94269 20.641 3.86508 20.5176C3.78747 20.3942 3.74752 20.2508 3.75012 20.105Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudiLogUser);
export default __webpack_public_path__ + "static/media/AudiLogUser.6e8ca54dc20562bf608bfb62c3f5ad18.svg";
export { ForwardRef as ReactComponent };